import React, { useEffect, useState } from "react";
import { Form, Input, Button, Upload, message, Typography, Card } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Title } = Typography;

const ServiceForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    form.setFieldsValue(formData);
    if (formData?.image) {
      setFileList([{ uid: "-1", name: "Uploaded Image", status: "done", url: `http://93.127.203.113:5005${formData.image}` }]);
    }
  }, [formData]);

  const handleFileChange = ({ fileList }) => setFileList(fileList);

  const onFinish = async (values) => {
    const payload = new FormData();
    Object.keys(values).forEach((key) => payload.append(key, values[key]));
    if (fileList.length > 0 && fileList[0].originFileObj) {
      payload.append("image", fileList[0].originFileObj);
    }

    try {
      if (formData?.id) {
        await axios.put(`http://93.127.203.113:5005/services/${formData.id}`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Service updated successfully");
      } else {
        await axios.post("http://93.127.203.113:5005/services", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Service created successfully");
      }
      refetchData();
      closeModal();
    } catch (error) {
      message.error("Error saving service.");
    }
  };

  return (
    <Card>
      <Title level={4}>{formData?.id ? "Edit Service" : "Create Service"}</Title>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item label="Title" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description" rules={[{ required: true }]}>
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="Upload Image">
          <Upload listType="picture" fileList={fileList} maxCount={1} beforeUpload={() => false} onChange={handleFileChange} onRemove={() => setFileList([])}>
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        </Form.Item>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form>
    </Card>
  );
};

export default ServiceForm;
